export const packagesActions = {
    SET_SCRIPTS: 'SET_SCRIPTS',
    GET_SCRIPTS: 'GET_SCRIPTS',
    GET_PACKAGES_OF_ENV_BUILD: 'GET_PACKAGES_OF_ENV_BUILD',
    GET_NEXT_REGULAR_PACKAGE_NAME:'GET_NEXT_REGULAR_PACKAGE_NAME',
    SET_NEXT_REGULAR_PACKAGE_NAME:'SET_NEXT_REGULAR_PACKAGE_NAME',
    GET_PACKAGES_OF_ENV: 'GET_PACKAGES_OF_ENV',
    GET_PACKAGE_OF_ENV: 'GET_PACKAGE_OF_ENV',
    GET_PACKAGE_OF_ENV_WITH_JOBID: 'GET_PACKAGE_OF_ENV_WITH_JOBID',
    SET_PACKAGE_OF_ENV_WITH_JOBID: 'SET_PACKAGE_OF_ENV_WITH_JOBID',
    SET_PACKAGES: 'SET_PACKAGES',
    SET_PACKAGES_OF_ENV: 'SET_PACKAGES_OF_ENV',
    SET_PACKAGE_OF_ENV: 'SET_PACKAGE_OF_ENV',
    GET_PACKAGES: 'GET_PACKAGES',
    NO_ITEMS_PACKAGES: 'NO_ITEMS_PACKAGES',
    ADD_PACKAGE: 'ADD_PACKAGE',
    DELETE_PACKAGE: 'DELETE_PACKAGE',
    ADD_SCRIPT_TO_PACKAGE: 'ADD_SCRIPT_TO_PACKAGE',
    ADD_SCRIPT_TO_PACKAGE_WITH_SCRIPT_TYPE: 'ADD_SCRIPT_TO_PACKAGE_WITH_SCRIPT_TYPE',
    CHANGE_SCRIPT_TYPE: 'CHANGE_SCRIPT_TYPE',
    REMOVE_SCRIPT_TO_PACKAGE: 'REMOVE_SCRIPT_TO_PACKAGE',
    REFRESH_PACKAGES: 'REFRESH_PACKAGES',
    REORDER_SCRIPTS: 'REORDER_SCRIPTS',
    IMPORT_SCRIPTS: 'IMPORT_SCRIPTS',
    SET_ENABLE_OR_DISABLE_FOR_PACKAGE: 'SET_ENABLE_OR_DISABLE_FOR_PACKAGE',
    SET_IS_ADHOC_FOR_PACKAGE: 'SET_IS_ADHOC_FOR_PACKAGE',
    DELETE_SCRIPTS_WITHOUT_PACAKGE: 'DELETE_SCRIPTS_WITHOUT_PACAKGE',
    DELETE_SCRIPT_LIST_WITHOUT_PACAKGE: 'DELETE_SCRIPT_LIST_WITHOUT_PACAKGE',
    ADD_PACKAGE_EXCLUSION: 'ADD_PACKAGE_EXCLUSION',
    UPDATE_PACKAGE_SCRIPT: 'UPDATE_PACKAGE_SCRIPT',
    UPLOAD_PACKAGE_SCRIPT: 'UPLOAD_PACKAGE_SCRIPT',
    DELETE_PACKAGE_EXCLUSION: 'DELETE_PACKAGE_EXCLUSION',
    TEST_PACKAGE: 'TEST_PACKAGE',
    RESET_STATE: 'RESET_STATE',
    GET_AFFECTED_OBJECTS: 'GET_AFFECTED_OBJECTS',
    IGNORE_SCRIPT_WARNING: 'IGNORE_SCRIPT_WARNING',
    RESET_DEPLOYED_PACKAGES_DATA: 'RESET_DEPLOYED_PACKAGES_DATA',
    PROMOTE_DEMOTE_PACKAGE: 'PROMOTE_DEMOTE_PACKAGE',
    GET_VERSION_SUGGESTED_FOR_PROMOTIONS: 'GET_VERSION_SUGGESTED_FOR_PROMOTIONS',
    GET_PACKAGE_INFO: 'GET_PACKAGE_INFO',
    GET_EFFECTIVE_DEPLOYED_PACKAGES: 'GET_EFFECTIVE_DEPLOYED_PACKAGES',
    GET_EFFECTIVE_DEPLOYED_PACKAGES_HISTORY: 'GET_EFFECTIVE_DEPLOYED_PACKAGES_HISTORY',
    SET_EFFECTIVE_DEPLOYED_PACKAGES: 'SET_EFFECTIVE_DEPLOYED_PACKAGES',
    SET_EFFECTIVE_DEPLOYED_PACKAGES_HISTORY: 'SET_EFFECTIVE_DEPLOYED_PACKAGES_HISTORY',
    DELETE_DEPLOYED_PACKAGE: 'DELETE_DEPLOYED_PACKAGE',
    GET_PACKAGES_BY_WILDCARD_AND_LIMIT: 'GET_PACKAGES_BY_WILDCARD_AND_LIMIT',
    SET_PACKAGES_BY_WILDCARD_AND_LIMIT: 'SET_PACKAGES_BY_WILDCARD_AND_LIMIT'
};

const initState = {
    scripts: [],
    errorMessages: [],
    deployedPackages: [],
    packages: [],
    no_items_packages: false,
    //nextRegularPackage:[]
};

export const packagesReducer = (state = initState, action) => {
    switch (action.type) {
        case packagesActions.SET_SCRIPTS:
        case packagesActions.SET_PACKAGES:
        case packagesActions.SET_PACKAGES_OF_ENV:
        case packagesActions.SET_PACKAGE_OF_ENV_WITH_JOBID:
        case packagesActions.NO_ITEMS_PACKAGES:
        case packagesActions.SET_EFFECTIVE_DEPLOYED_PACKAGES_HISTORY:
        case packagesActions.SET_PACKAGES_BY_WILDCARD_AND_LIMIT:
        case packagesActions.SET_PACKAGE_OF_ENV:
        case packagesActions.SET_NEXT_REGULAR_PACKAGE_NAME:
        case packagesActions.SET_EFFECTIVE_DEPLOYED_PACKAGES: 
            return Object.assign({}, state, action.payload);


        case packagesActions.DELETE_SCRIPTS_WITHOUT_PACAKGE:
            return Object.assign({}, state, {
                scripts: state.scripts.filter(item => item.id != action.payload.scriptId)
            });

        case packagesActions.RESET_STATE:
            return initState;

        case packagesActions.RESET_DEPLOYED_PACKAGES_DATA:
            return Object.assign({}, state, { deployedPackages: [] });

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/packagesReducer.ts